export const initialValuesRegister = {
  name: "",
  email: "",
  password: "",
  confirmPassword: "",
}
